import { css, useTheme } from '@fable/theme'
import { PageContainerV2 } from 'components/v2'
import { useBranchView } from 'hooks'
import { SearchFilter } from '../../../../components/search_filters/SearchFilter'
import { HomeClubsSearch } from './HomeClubsSearch'
import { useHome } from 'app/marketing/context'

export const HomeClubsDiscovery = () => {
  const { colors, breakpoints, mediaQueries } = useTheme()
  const bannerInView = useBranchView()
  const { genres, loading } = useHome()

  return (
    <div
      className={css`
        position: sticky;
        top: ${bannerInView ? '122px' : '60px'};
        background-color: ${colors.uiWhite};
        z-index: 2;
      `}
    >
      <PageContainerV2
        className={css`
          @media only screen and (max-width: ${breakpoints.mobileL}px) {
            padding-left: 0;
            padding-right: 0;
          }
          ${mediaQueries.mobileL} {
            overflow: visible;
          }
        `}
      >
        <div
          className={css`
            padding: 16px 0;
            position: relative;
          `}
        >
          <HomeClubsSearch />
          <SearchFilter filters={genres} loading={loading} />
        </div>
      </PageContainerV2>
    </div>
  )
}
